import React, { useContext } from 'react';
import styled from 'styled-components';
import blue from '@material-ui/core/colors/blue';
import { Alert } from '@material-ui/lab';

import { UserContext } from '../../user/User.context';
import { useWorkflowContext } from '../../secure-portal/workflow/Workflow.context';

const StyledHeader = styled.div`
  display: flex;
  color: #fff;
  padding: 42px 0;
  align-items: center;
  white-space: nowrap;
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    color: #fff;
  }
  h2 {
    font-size: 22px;
    /* one line with ellipsis */
    display: -webkit-box;
    overflow: hidden;
    padding-right: 8px;
    white-space: pre-wrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .subtitle {
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.8);
  }
  a {
    color: #fff;
    &:hover {
      color: ${blue[100]};
    }
  }
  ${props => props.theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
    padding: 0;
    h1,
    h2,
    h3,
    h4 {
      flex: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .MuiBreadcrumbs-root {
      flex: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      ol {
        flex-wrap: nowrap;
        /* justify-content: flex-end;
        padding-right: 10px; */
      }
    }
    .page-template-header-actions {
      flex: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .search-box {
      order: 5;
      flex: 100%;
      margin: 30px 0 0 0;
      .search {
        padding: 12px;
        max-width: 100%;
        border-radius: 4px 4px 0 0;
        border-bottom: 1px solid #eee;
      }
    }
  }
`;

const StyledCardHeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  &.flex {
    flex: 1;
  }
  .MuiButton-label {
    /* overflow: hidden;
    text-overflow: ellipsis; */
    /* display: inline-block; */
  }
  .flex-label .MuiButton-label {
    display: flex;
  }
  button,
  .button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  .cart-button {
    margin-right: 16px;
  }
`;

const StyledAlert = styled(Alert)`
  justify-content: center;
`;

export interface PageTemplateHeaderActionsProps {
  flex?: boolean;
}

export const PageTemplateHeaderActions: React.FC<PageTemplateHeaderActionsProps> = props => {
  const { flex, children } = props;
  return (
    <StyledCardHeaderActions
      className={`page-template-header-actions ${flex && 'flex'}`}
    >
      {children}
    </StyledCardHeaderActions>
  );
};

const PageTemplateHeader: React.FC = props => {
  const { children } = props;
  const { user } = useContext(UserContext);
  const { error } = useWorkflowContext();
  const noRoles: boolean = user?.roles?.length === 0;
  const showAlert: boolean = noRoles || !!error;
  return (
    <>
      <StyledHeader className='page-template-header'>{children}</StyledHeader>
      {showAlert && (
        <StyledAlert severity='warning' className='page-template-alert'>
          {noRoles ? (
            <>
              Your account is not completely setup. Please contact your
              administrator to update your account permissions.
            </>
          ) : (
            <>
              {error?.message} Please contact your administrator to update the
              workflow settings.
            </>
          )}
        </StyledAlert>
      )}
    </>
  );
};

export default PageTemplateHeader;
